import React, { useState, useEffect } from 'react';
import MapService from './../utils/MapService';
import Slider from "react-slick";
import SubsidiaryItem from './bper-subsidiary-item';
import parseHTML from "html-react-parser";

export default function ClosestSubsidiaries({ bank, translations, groupId, subsidiaryId }) {
	const [configurations, setConfigurations] = useState(undefined);
	const [subsidiaries, setSubsidiaries] = useState(undefined);
	const apiKey = configurations && configurations.googleApiKey;
	const [isCarousel, setIsCarousel] = useState(false);

	useEffect(() => {
		getConfigurations(bank);
		detectCarousel(subsidiaries);
	}, []);

	useEffect(() => {
		configurations && getClosestSubsidiaries(configurations.countClosestSubsidiaries);
	}, [configurations]);

	useEffect(() => {
		detectCarousel(subsidiaries);
	}, [window.innnerWidth]);

	const detectCarousel = (subsidiaries) => {
		if (window.innnerWidth > 991) {
			setIsCarousel(subsidiaries && subsidiaries.length > 3);
		} else {
			setIsCarousel(subsidiaries && subsidiaries.length > 1);
		}
	}

	const settings = {
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: (
			<div>
				<button className="carousel-arrow next-arrow">
					<svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="0 0 34 24" fill="currentColor">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M26.422 6.73191C26.274 6.49882 25.965 6.42989 25.7319 6.57795C25.4988 6.72602 25.4299 7.03501 25.578 7.2681C26.3614 8.50149 27.031 9.43762 27.8221 10.2448C28.2659 10.6976 28.7427 11.1047 29.2918 11.5H1C0.723858 11.5 0.5 11.7239 0.5 12C0.5 12.2761 0.723858 12.5 1 12.5H29.0921C28.5138 12.8859 28.0302 13.2917 27.6 13.7448C26.8125 14.5741 26.2263 15.5391 25.5609 16.7609C25.4288 17.0034 25.5184 17.307 25.7609 17.4391C26.0034 17.5712 26.307 17.4817 26.4391 17.2391C27.0978 16.0297 27.6329 15.1624 28.3251 14.4334C29.0102 13.7119 29.8717 13.103 31.2081 12.4548C31.2146 12.4518 31.221 12.4487 31.2273 12.4455L32.0661 12.0392L31.2579 11.5716C31.2527 11.5684 31.2475 11.5654 31.2422 11.5625C30.0684 10.8827 29.2488 10.2719 28.5363 9.54488C27.8186 8.81258 27.1932 7.94596 26.422 6.73191Z" fill="currentColor"/>
					</svg>
				</button>
			</div>
		),
		prevArrow: (
			<div>
				<button className="carousel-arrow prev-arrow">
					<svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="0 0 34 24" fill="currentColor">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M7.71076 6.73191C7.85883 6.49882 8.16782 6.42989 8.40091 6.57795C8.634 6.72602 8.70293 7.03501 8.55486 7.2681C7.77138 8.50149 7.10179 9.43762 6.31067 10.2448C5.86695 10.6976 5.39009 11.1047 4.84099 11.5H33.1328C33.409 11.5 33.6328 11.7239 33.6328 12C33.6328 12.2761 33.409 12.5 33.1328 12.5H5.04066C5.61905 12.8859 6.1026 13.2917 6.53284 13.7448C7.32028 14.5741 7.90656 15.5391 8.57192 16.7609C8.70399 17.0034 8.61446 17.307 8.37195 17.4391C8.12944 17.5712 7.82578 17.4817 7.69371 17.2391C7.03505 16.0297 6.49992 15.1624 5.80766 14.4334C5.12259 13.7119 4.26114 13.103 2.9247 12.4548C2.91824 12.4518 2.91186 12.4487 2.90556 12.4455L2.06668 12.0392L2.87492 11.5716C2.88008 11.5684 2.88531 11.5654 2.8906 11.5625C4.0644 10.8827 4.88399 10.2719 5.59648 9.54488C6.31418 8.81258 6.93957 7.94596 7.71076 6.73191Z" fill="currentColor"/>
					</svg>
				</button>
			</div>
		),
		responsive: [
			{
				breakpoint: 991,
				settings: {
					arrows: false,
					slidesToShow: 1.1,
				}
			}
		]
	}

	const getConfigurations = (bank) => {
		MapService.getConfigurations(bank).then((response) => {
			if (response) {
				setConfigurations(response.data);
			}
		});
	};

	const getClosestSubsidiaries = (limitResults) => {
		MapService.getClosestSubsidiary(bank, limitResults, groupId, subsidiaryId).then((response) => {
			const subsidiaries = response?.data?.payload?.subsidiaryListGeoloc
			if (subsidiaries) {
				setSubsidiaries(subsidiaries);
				detectCarousel(subsidiaries);
			}
		});
	}

	return (
		<div className="filiali-bper light-neutral-20">
			{subsidiaries &&
				<div className={"closest-subsidiaries n-" + subsidiaries.length + " is-carousel-" + isCarousel}>
					<div className="closest-subsidiaries-wrapper">
						<h3 className="title | font-heading-l font-heading-desktop-xxl fw-400 position-relative text-center">
							{parseHTML(translations.closestPortletTitle)}
						</h3>
						{
							isCarousel ?
								<Slider {...settings}>
									{subsidiaries.map((el, index) =>
										<SubsidiaryItem key={index} translations={translations} apiKey={apiKey} subsidiary={el} />
									)}
								</Slider>
								:
								<div className="all-subsidiaries">
									{subsidiaries.map((el, index) =>
										<SubsidiaryItem key={index} translations={translations} apiKey={apiKey} subsidiary={el} />
									)}
								</div>
						}
					</div>
				</div>
			}
		</div>
	);
}